module.exports = __webpack_public_path__ + "static/007312-97c2b32b2f13a08d7b15118ce90b08a4.jpg";